module.exports = __webpack_public_path__ + "static/img/h-first.ba36e2ab.webp";